import React from 'react'

export function StormMonk({ className = '', pose = 'idle' }) {
  return (
    <svg
      viewBox="0 0 200 300"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sm-skinGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#d97706" />
          <stop offset="100%" stopColor="#92400e" />
        </linearGradient>
        <linearGradient id="sm-giGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f8fafc" />
          <stop offset="100%" stopColor="#cbd5e1" />
        </linearGradient>
        <filter
          id="sm-lightningGlow"
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
        >
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="sm-blastGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
          @keyframes sm-stance {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            50% { transform: translateY(3px) rotate(1deg); }
          }
          @keyframes sm-zap {
            0%, 90% { opacity: 0; }
            92% { opacity: 1; }
            94% { opacity: 0; }
            96% { opacity: 1; }
            100% { opacity: 0; }
          }
          @keyframes sm-zapAlt {
            0%, 40% { opacity: 0; }
            42% { opacity: 1; }
            44% { opacity: 0; }
            46% { opacity: 1; }
            100% { opacity: 0; }
          }
          @keyframes sm-kick {
            0%, 100% { transform: translateX(0); }
            50% { transform: translateX(10px); }
          }
          @keyframes sm-uppercut {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
          }
          @keyframes sm-knockback {
            0%, 100% { transform: translateX(0) rotate(10deg); }
            50% { transform: translateX(5px) rotate(15deg); }
          }
          @keyframes sm-meditate {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
          }
          @keyframes sm-spherePulse {
            0%, 100% { transform: scale(1); opacity: 0.6; }
            50% { transform: scale(1.05); opacity: 0.8; }
          }
          
          .sm-idle-anim { animation: sm-stance 2s ease-in-out infinite; transform-origin: bottom center; }
          .sm-lightning-1 { animation: sm-zap 3s infinite; }
          .sm-lightning-2 { animation: sm-zapAlt 2.5s infinite; }
          .sm-attack-anim { animation: sm-kick 0.3s ease-in-out infinite; }
          .sm-jump-anim { animation: sm-uppercut 1.5s ease-in-out infinite; }
          .sm-hurt-anim { animation: sm-knockback 0.5s ease-in-out infinite; transform-origin: bottom center; }
          .sm-block-anim { animation: sm-meditate 3s ease-in-out infinite; }
          .sm-sphere-anim { animation: sm-spherePulse 2s ease-in-out infinite; transform-origin: center; }
        `}
      </style>

      {pose === 'idle' && (
        <g className="sm-idle-anim">
          <path
            d="M30 150 L 10 120 L 40 100 L 20 70"
            stroke="#fef08a"
            strokeWidth="3"
            fill="none"
            filter="url(#sm-lightningGlow)"
            className="sm-lightning-1"
          />
          <path
            d="M170 200 L 190 170 L 160 150 L 180 120"
            stroke="#38bdf8"
            strokeWidth="3"
            fill="none"
            filter="url(#sm-lightningGlow)"
            className="sm-lightning-2"
          />
          <path
            d="M110 160 L160 240 L130 250 L90 170 Z"
            fill="url(#sm-giGrad)"
          />
          <path d="M140 240 L170 245 L160 260 L130 255 Z" fill="#1e293b" />
          <path
            d="M120 90 L160 60 L170 75 L130 105 Z"
            fill="url(#sm-skinGrad)"
          />
          <circle cx="165" cy="65" r="12" fill="url(#sm-skinGrad)" />
          <circle
            cx="165"
            cy="65"
            r="18"
            fill="none"
            stroke="#fef08a"
            strokeWidth="2"
            filter="url(#sm-lightningGlow)"
            className="sm-lightning-1"
          />
          <path
            d="M70 80 L130 80 L110 160 L80 160 Z"
            fill="url(#sm-skinGrad)"
          />
          <path
            d="M100 80 L100 150 M80 110 Q 100 120 120 110 M85 130 Q 100 135 115 130"
            stroke="#78350f"
            strokeWidth="2"
            fill="none"
            opacity="0.5"
          />
          <path d="M75 155 L115 155 L120 170 L70 170 Z" fill="#0284c7" />
          <path d="M90 165 L80 210 L95 210 L100 165 Z" fill="#0284c7" />
          <path d="M80 160 L40 230 L70 240 L100 170 Z" fill="url(#sm-giGrad)" />
          <path d="M45 230 L75 235 L65 255 L35 250 Z" fill="#1e293b" />
          <path d="M80 90 L40 110 L50 130 L90 110 Z" fill="url(#sm-skinGrad)" />
          <circle cx="45" cy="120" r="15" fill="url(#sm-skinGrad)" />
          <circle
            cx="45"
            cy="120"
            r="22"
            fill="none"
            stroke="#38bdf8"
            strokeWidth="2"
            filter="url(#sm-lightningGlow)"
            className="sm-lightning-2"
          />
          <g transform="translate(100, 55)">
            <circle cx="0" cy="0" r="22" fill="url(#sm-skinGrad)" />
            <rect x="-22" y="-10" width="44" height="8" fill="#fef08a" />
            <path d="M20 -6 L 40 -15 L 35 -5 Z" fill="#fef08a" />
            <circle
              cx="-8"
              cy="5"
              r="3"
              fill="#ffffff"
              filter="url(#sm-lightningGlow)"
            />
            <circle
              cx="8"
              cy="5"
              r="3"
              fill="#ffffff"
              filter="url(#sm-lightningGlow)"
            />
          </g>
        </g>
      )}

      {pose === 'attack' && (
        <g className="sm-attack-anim">
          {/* Flying Kick Pose */}
          <g transform="translate(100, 150) rotate(-70)">
            {/* Back Leg (tucked) */}
            <path d="M-20 20 L-60 60 L-40 80 L0 40 Z" fill="url(#sm-giGrad)" />

            {/* Torso */}
            <path
              d="M-30 -40 L30 -40 L20 40 L-20 40 Z"
              fill="url(#sm-skinGrad)"
            />
            <path d="M-25 35 L25 35 L30 50 L-30 50 Z" fill="#0284c7" />

            {/* Arms pulled back */}
            <path
              d="M-30 -30 L-70 -10 L-60 10 L-20 -10 Z"
              fill="url(#sm-skinGrad)"
            />
            <path
              d="M30 -30 L70 -10 L60 10 L20 -10 Z"
              fill="url(#sm-skinGrad)"
            />

            {/* Head */}
            <g transform="translate(0, -65)">
              <circle cx="0" cy="0" r="22" fill="url(#sm-skinGrad)" />
              <rect x="-22" y="-10" width="44" height="8" fill="#fef08a" />
              <path d="M20 -6 L 40 -15 L 35 -5 Z" fill="#fef08a" />
              <circle
                cx="-8"
                cy="5"
                r="3"
                fill="#ffffff"
                filter="url(#sm-lightningGlow)"
              />
              <circle
                cx="8"
                cy="5"
                r="3"
                fill="#ffffff"
                filter="url(#sm-lightningGlow)"
              />
            </g>

            {/* Front Leg (Extended Kick) */}
            <path d="M0 40 L0 140 L20 140 L20 40 Z" fill="url(#sm-giGrad)" />
            <path d="M-5 140 L25 140 L20 160 L0 160 Z" fill="#1e293b" />

            {/* Massive Lightning on Kick */}
            <path
              d="M-20 40 L30 90 L-10 120 L40 160"
              stroke="#fef08a"
              strokeWidth="6"
              fill="none"
              filter="url(#sm-blastGlow)"
            />
            <path
              d="M40 40 L-10 90 L30 120 L-20 160"
              stroke="#38bdf8"
              strokeWidth="4"
              fill="none"
              filter="url(#sm-blastGlow)"
            />
            <circle
              cx="10"
              cy="160"
              r="30"
              fill="#fef08a"
              filter="url(#sm-blastGlow)"
              opacity="0.8"
            />
          </g>
        </g>
      )}

      {pose === 'jump' && (
        <g className="sm-jump-anim">
          {/* Rising Uppercut */}

          {/* Full body aura */}
          <ellipse
            cx="100"
            cy="150"
            rx="60"
            ry="120"
            fill="none"
            stroke="#38bdf8"
            strokeWidth="2"
            filter="url(#sm-lightningGlow)"
            className="sm-lightning-1"
          />

          {/* Legs straight down */}
          <path
            d="M80 160 L80 260 L100 260 L100 160 Z"
            fill="url(#sm-giGrad)"
          />
          <path
            d="M100 160 L120 250 L140 250 L120 160 Z"
            fill="url(#sm-giGrad)"
          />

          {/* Torso stretched up */}
          <path
            d="M75 70 L125 70 L115 160 L85 160 Z"
            fill="url(#sm-skinGrad)"
          />
          <path d="M80 155 L120 155 L125 170 L75 170 Z" fill="#0284c7" />

          {/* Left arm down */}
          <path d="M75 80 L50 140 L65 150 L90 90 Z" fill="url(#sm-skinGrad)" />

          {/* Right arm straight up (Uppercut) */}
          <path
            d="M125 80 L140 10 L160 15 L140 90 Z"
            fill="url(#sm-skinGrad)"
          />
          <circle cx="145" cy="5" r="15" fill="url(#sm-skinGrad)" />

          {/* Uppercut Lightning */}
          <path
            d="M145 5 L120 -40 M145 5 L170 -30 M145 5 L145 -50"
            stroke="#fef08a"
            strokeWidth="4"
            fill="none"
            filter="url(#sm-blastGlow)"
          />
          <circle
            cx="145"
            cy="5"
            r="25"
            fill="#fef08a"
            filter="url(#sm-blastGlow)"
            opacity="0.7"
          />

          {/* Head looking up */}
          <g transform="translate(100, 45) rotate(-20)">
            <circle cx="0" cy="0" r="22" fill="url(#sm-skinGrad)" />
            <rect x="-22" y="-10" width="44" height="8" fill="#fef08a" />
            <path d="M20 -6 L 40 10 L 35 20 Z" fill="#fef08a" />
            <circle
              cx="-8"
              cy="0"
              r="3"
              fill="#ffffff"
              filter="url(#sm-lightningGlow)"
            />
            <circle
              cx="8"
              cy="0"
              r="3"
              fill="#ffffff"
              filter="url(#sm-lightningGlow)"
            />
          </g>
        </g>
      )}

      {pose === 'hurt' && (
        <g className="sm-hurt-anim">
          {/* Dissipating Lightning */}
          <path
            d="M20 100 L 40 120 M 180 150 L 160 170 M 50 250 L 30 230"
            stroke="#38bdf8"
            strokeWidth="2"
            fill="none"
            opacity="0.5"
          />

          {/* Knocked back legs */}
          <path
            d="M100 170 L150 220 L170 210 L120 160 Z"
            fill="url(#sm-giGrad)"
          />
          <path
            d="M80 170 L100 250 L120 240 L100 160 Z"
            fill="url(#sm-giGrad)"
          />

          {/* Torso arched back */}
          <path
            d="M90 90 L150 100 L120 170 L80 160 Z"
            fill="url(#sm-skinGrad)"
          />
          <path d="M85 155 L125 165 L120 180 L80 170 Z" fill="#0284c7" />

          {/* Arms splayed */}
          <path d="M90 90 L40 70 L50 50 L100 80 Z" fill="url(#sm-skinGrad)" />
          <path
            d="M150 100 L200 130 L190 150 L140 120 Z"
            fill="url(#sm-skinGrad)"
          />

          {/* Head thrown back */}
          <g transform="translate(130, 60) rotate(45)">
            <circle cx="0" cy="0" r="22" fill="url(#sm-skinGrad)" />
            <rect x="-22" y="-10" width="44" height="8" fill="#fef08a" />
            {/* Headband flying off */}
            <path d="M20 -6 L 60 -30 L 55 -20 Z" fill="#fef08a" />
            {/* Eyes shut/wincing */}
            <path
              d="M-12 5 L -4 5 M 4 5 L 12 5"
              stroke="#451a03"
              strokeWidth="2"
            />
          </g>
        </g>
      )}

      {pose === 'block' && (
        <g className="sm-block-anim">
          {/* Lightning Sphere Shield */}
          <circle
            cx="100"
            cy="150"
            r="90"
            fill="#38bdf8"
            opacity="0.2"
            filter="url(#sm-blastGlow)"
            className="sm-sphere-anim"
          />
          <circle
            cx="100"
            cy="150"
            r="90"
            fill="none"
            stroke="#fef08a"
            strokeWidth="2"
            filter="url(#sm-lightningGlow)"
            className="sm-lightning-1"
          />
          <circle
            cx="100"
            cy="150"
            r="85"
            fill="none"
            stroke="#38bdf8"
            strokeWidth="2"
            filter="url(#sm-lightningGlow)"
            className="sm-lightning-2"
          />

          {/* Cross-legged Meditating */}
          <g transform="translate(100, 180)">
            {/* Legs crossed */}
            <path d="M-40 0 L40 0 L20 40 L-20 40 Z" fill="url(#sm-giGrad)" />
            <path d="M-50 10 L0 40 L-10 50 L-60 20 Z" fill="url(#sm-giGrad)" />
            <path d="M50 10 L0 40 L10 50 L60 20 Z" fill="url(#sm-giGrad)" />

            {/* Torso upright */}
            <path
              d="M-25 -70 L25 -70 L20 0 L-20 0 Z"
              fill="url(#sm-skinGrad)"
            />
            <path d="M-22 -10 L22 -10 L25 5 L-25 5 Z" fill="#0284c7" />

            {/* Arms together (praying hands) */}
            <path
              d="M-25 -60 L-10 -20 L0 -30 L-15 -70 Z"
              fill="url(#sm-skinGrad)"
            />
            <path
              d="M25 -60 L10 -20 L0 -30 L15 -70 Z"
              fill="url(#sm-skinGrad)"
            />
            <circle cx="0" cy="-25" r="8" fill="url(#sm-skinGrad)" />

            {/* Head calm */}
            <g transform="translate(0, -95)">
              <circle cx="0" cy="0" r="22" fill="url(#sm-skinGrad)" />
              <rect x="-22" y="-10" width="44" height="8" fill="#fef08a" />
              <path d="M20 -6 L 30 10 L 25 15 Z" fill="#fef08a" />
              {/* Glowing calm eyes */}
              <circle
                cx="-8"
                cy="5"
                r="2"
                fill="#ffffff"
                filter="url(#sm-lightningGlow)"
              />
              <circle
                cx="8"
                cy="5"
                r="2"
                fill="#ffffff"
                filter="url(#sm-lightningGlow)"
              />
            </g>
          </g>
        </g>
      )}
    </svg>
  )
}
